export default "__VITE_ASSET__7TrfA1Yl__"